// home
export const HomePath = '/';
export const NewsAndKnowledgePath = '/news-and-knowledge';

// manage
export const ManagePersonalRequestsPath = '/manage/personal/my-support';
export const ManagePersonalApprovalsPath = `${ManagePersonalRequestsPath}?type=approvals`;
export const ManagePersonalTechnologyPath = '/manage/my-technology';
export const ManageOrderPath = '/manage/personal/order';
export const ManageRequestVMPath = '/manage/personal/request-vd';
export const ManageRequestVAPath = '/manage/personal/request-va';
export const ManageIncidentTicketPath = '/support/incident-tickets';
export const ManageRequestTicketPath = '/manage/my-activities/request-tickets';


// get-support
export const GetSupportPath = '/support/knowledge';
export const GetSupportLandingPath = '/support';
export const GetTopKnowledgeArticlePath = '/support/top-knowledge-articles';
export const GetSupportSearchPath = '/get-support/search';
export const IncidentCreationPath = '/get-support/incident';
export const IncidentConfirmationPath = '/get-support/incident/confirmation';

// Knowledge detail
export const KnowledgeDetail = '/knowledge/detail/:id';

// others
export const ChatPath = '/chat';
export const LoginPath = '/login';
export const SearchPath = '/search';
export const PcRefreshPath = '/pc-refresh';
export const PilotModePath = '/pilot';
export const AssignmentIssuePath = '/i-dont-have-this-device';
export const PcReturnPath = '/pc-return';
export const PcLostAndStolenPath = '/pc-lost-stolen';
export const PcReportBroken = '/pc-report-broken';
export const PcRegisterDevicePath = '/pc-register-device';
export const PcReturnAnyDevicePath = '/pc-return-unknown-device';

export const NavigationKnowledgePath = '/get-support';
export const NavigationApprovalTicketsPath = `${ManagePersonalRequestsPath}?type=approvals`;
export const NavigationTicketsPath = `${ManagePersonalRequestsPath}?type=incidents`;
export const NavigationRequestTicketsPath = `${ManagePersonalRequestsPath}?type=requests`;
export const CompanyPortal = 'companyportal://';

export const EditPreferencePath = '/profile/update';
export const NotFoundPath = '/404';

export const ManageOutagesPath = '/outages';

export const ManageDevicesPath = '/manage/my-team';

export const GlobalSearchPath = '/global-search';

// Analytics
export const AnalyticsPath = '/analytics';

//Shopping cart
export const ShoppingCartPath = '/marketplace/shopping-cart';

//Order request Confirmation
export const OrderRequestPath = '/marketplace/order-request';
// Marketplace
export const MarketplacePath = '/marketplace';
export const MarketplaceCategoryPath = '/marketplace/category/*';
export const ProductDetailPath = `${MarketplaceCategoryPath}/product-detail`;

export const ManagePath = `/manage`;
export const MarketplaceApprovalsPath = `${ManagePath}/approvals`;
export const ViewOrderPath = `/manage/my-processes/view-order`;
export const ViewOrderDetailPath = `/manage/my-processes/view-order/:id`;

export const OnboardingPath = '/manage/my-team/onboarding';
export const NewJoinerPath = '/';

export const OffboardingPath = '/manage/my-team/offboarding';
export const LeaverPath = '/';

// teams login
export const TeamsLoginStartPath = '/teams/auth-start';
export const TeamsLoginEndPath = '/teams/auth-end';


export const AnalyticsPagePath = '/analytics';
export const PowerBIDashboardPath = `${AnalyticsPagePath}/operation/dashboard`;
export const ExperienceDashboardPath = `${AnalyticsPagePath}/experience/dashboard`;
export const ExperienceCustomDashboardPath = `${AnalyticsPagePath}/experience/custom-dashboard`;
export const CustomDashboardPagePath = `${AnalyticsPagePath}/operation/custom-dashboard`;

export const SoftwareRequestPagePath = '/marketplace/software-request/:productId';

// Services
export const ServicesPath = '/services';
export const IcAppsPath = '/services/ic-service-request/:scrn_key';
export const AutomatedServiceRequestPath = '/services/automated-service-request/:title';
// catalogs
export const CatalogServicePath = '/services/catalogs/:catalog_type_key';

export const CategorySoftwarePath = '/marketplace/category/Software';

// Offboarding
export const LastAccessPath = '/';